import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import { IActionButton } from './types';
import styles from './styles.module.css';

export const ActionButton: FC<IActionButton> = ({
  text,
  action,
  icon = 'arrowLongLeft',
  className,
}) => {
  return (
    <Span className={clsx(styles.root, className)} onClick={action}>
      <Icon type={IconType[icon]} className={styles.icon} />
      <Span className={styles.text}>{text}</Span>
    </Span>
  );
};
